import { IApplicationState, TBoardId } from '../../../types/types';
import { ILockStatus } from '../../../types/model';

export const getBoardLockStatus = (
    state: IApplicationState,
    boardId: TBoardId
): boolean => {
    return  state.model.dashboards[boardId] && state.model.dashboards[boardId].lockDate != null
};
